import theme from 'src/theme';
import {tableSx} from './ChatTable.sx';

export const customTableSx = {
    ...tableSx,
    thSortable: {
        ...tableSx.th,
        boxSizing: 'border-box' as const,
        cursor: 'pointer',
        userSelect: 'none' as const,
        '&:hover': {
            color: theme.palette.primary.main,
        },
    },
    thInner: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.4,
        verticalAlign: 'middle' as const,
    },
    sortIcon: {
        fontSize: 12,
        opacity: 0.5,
    },
    sortIconActive: {
        fontSize: 12,
        opacity: 1,
        color: theme.palette.primary.main,
    },
    emptyRow: {
        ...tableSx.td,
        textAlign: 'center' as const,
        color: theme.palette.neutral[400],
        fontSize: '0.72rem',
        py: 2,
    },
    footer: {
        ...tableSx.footer,
        justifyContent: 'flex-start' as const,
    },
};
